import React, { ReactNode, useState } from 'react';
import { Modal, CustomFlowbiteTheme, Popover, Tooltip, Pagination, Button } from "flowbite-react";
import { MdEditSquare } from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";


import StatusLabel from '../UtilityHelpers/StatusLabel';
import MessageBubbleSVG from '../../svgs/MessageBubbleSVG';

import ApiService from "../../services/ApiServiceClass";

import { useNavigate } from 'react-router-dom';
import { useLoader } from "../../hooks/useLoader";
import { useUtils } from "../../hooks/useUtils";
import { useGetRequestByMemberID } from '../../hooks/Request/useGetRequestByMemberID';

import CustomThemeModal from "../../components/CustomThemes/CustomThemeModal";
import CustomThemeButton from "../../components/CustomThemes/CustomThemeButton";

const MyRequestCard: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { requestsByMemberID, setRequestsByMemberID } = useGetRequestByMemberID();
  const [requestIDToDelete, setRequestIDToDelete] = useState(0);

  const helperUtils = useUtils();
  const navigate = useNavigate();
  const loader = useLoader();

  const requestContent = (nameItem: any) => {

    if (nameItem.is_primary) {
      return (
        <Popover content={<div className="w-max max-w-[311px] rounded bg-white drop-shadow-5 dark:bg-meta-4">
          <div className="border-b border-stroke p-3 dark:border-strokedark">
            <h4 className="text-center text-title-sm font-semibold text-black dark:text-white">
              {nameItem.name}
            </h4>
          </div>
          <div className="px-5 py-4.5">
            <p className="font-medium">
              <div>Total Requests: <span className="text-blue-400">{nameItem.totalRequest}</span></div>
              <div>Total Costs: <span className="text-blue-400">{helperUtils.convertToMoney(parseFloat(nameItem.totalCosts))}</span></div>
            </p>
          </div>
        </div>} trigger="hover"><div className="text-orange-500">* {nameItem.name}</div></Popover>
      )
    } else {
      return <div>{nameItem.name}</div>
    }

  }

  const createNewRequest = async () => {
    setOpenModal(false);

    loader?.setIsLoading(true);
    try {
      const responseData = await ApiService.saveInitDraft();
      loader?.setIsLoading(false);
      navigate('/request/request-details?id=' + responseData.data);
    } catch (error) {
      loader?.setIsLoading(false);
      navigate("/login");
    }
  }

  const cancelCreateNew = () => {
    setOpenModal(false);
  }

  const handleCreateNewRequest = () => {
    setOpenModal(true);
  }

  const handleEditRequest = (id: number) => {
    navigate('/request/request-details?id=' + id);
  }

  const handleEditRequestFromURL = (status: string, id: number) => {
    if (status === 'New' || status === 'Waitlisted' || status === 'Draft' ) {
      navigate('/request/request-details?id=' + id);
    } else {
      navigate('/request/view-request-details?id=' + id);
    }
  }

  const handleDeleteRequest = (id: number) => {
    setRequestIDToDelete(id);
    setOpenDeleteModal(true);
  }

  const handleSureToDeleteRequest = () => {
    try {
      loader?.setIsLoading(true);
      ApiService.deleteRequest(requestIDToDelete)
        .then(() => {
          const filteredRequests = requestsByMemberID.filter(item => item.id !== requestIDToDelete);
          setRequestsByMemberID(filteredRequests);
          setOpenDeleteModal(false);
          loader?.setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          loader?.setIsLoading(false);
          setOpenDeleteModal(false);
          navigate("/login");
        });
    } catch (error) {
      loader?.setIsLoading(false);
      console.error(error);
    }
    setOpenDeleteModal(false);
  }

  return (
    <div className="col-span-12 rounded-sm border border-stroke bg-white px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5">
      <h5 className="text-xl font-semibold text-black dark:text-white">
        My Requests
      </h5>

      <div className="py-5">
        <Button onClick={() => handleCreateNewRequest()}>Create A New Request</Button>
      </div>
      <div className='overflow-auto'>
        <table className="w-full table-auto mt-5">
          <thead>
            <tr className="bg-gray-2 text-left dark:bg-meta-4">
              <th className="min-w-[50px] py-4 px-4 font-medium text-black dark:text-white xl:pl-11">

              </th>
              <th className="min-w-[220px] py-4 px-4 font-medium text-black dark:text-white xl:pl-11">
                Names
              </th>
              <th className="min-w-[150px] py-4 px-4 font-medium text-black dark:text-white">
                Title
              </th>
              <th className="min-w-[150px] py-4 px-4 font-medium text-black dark:text-white">
                Description
              </th>
              <th className="min-w-[150px] py-4 px-4 font-medium text-black dark:text-white">
                Date
              </th>
              <th className="min-w-[120px] py-4 px-4 font-medium text-black dark:text-white">
                Status
              </th>
              <th className="min-w-[120px] py-4 px-4 font-medium text-black dark:text-white">
                Total Cost
              </th>
              <th className="py-4 px-4 font-medium text-black dark:text-white">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {requestsByMemberID.map((item, key) => { 

              const descriptionMaxLength = 50;
              const truncatedDescription = item.description.length > descriptionMaxLength
                    ? `${item.description.substring(0, descriptionMaxLength)}...`
                    : item.description;

              return (
              <tr key={key}>
                <td className="border-b border-[#eee] py-5 px-2 dark:border-strokedark">
                  { item.comment_count > 0 && <h5 className="font-medium text-black dark:text-white">
                    <span className="cursor-pointer hover:text-yellow-300"><MessageBubbleSVG /></span>
                  </h5>}                  
                </td>
                <td className="border-b border-[#eee] py-5 px-4 pl-9 dark:border-strokedark xl:pl-11">
                  <h5 className="font-medium text-black dark:text-white">
                    {
                      item.names.map((nameItem) => {
                        return requestContent(nameItem)
                      })
                    }
                  </h5>
                </td>
                <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                  <p className="text-primary hover:text-blue-400 dark:text-primary dark:hover:text-blue-400 cursor-pointer" onClick={() => handleEditRequestFromURL(item.status, item.id)}>                  
                      {item.title}
                  </p>
                </td>                
                <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                  <p className="text-black dark:text-white">
                          {truncatedDescription}
                      </p>                    
                </td>                
                <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                  <p className="text-black dark:text-white">
                    {item.request_date}
                  </p>
                </td>
                <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark text-center">
                  <StatusLabel statusLabel={item.status} />
                </td>
                <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                  <p className="text-green-600 dark:text-green-400 text-right">
                    {helperUtils.convertToMoney(item.total_cost)}
                  </p>
                </td>
                <td className="border-b border-[#eee] py-5 px-4 dark:border-strokedark">
                  <div className="flex items-center space-x-3.5">
                    {(item.status === 'New' || item.status === 'Waitlisted' || item.status === 'Draft') && <Tooltip content="Edit Request" style="light" arrow={false}>
                      <button className="hover:text-primary">
                        <MdEditSquare  className='text-xl' onClick={() => handleEditRequest(item.id)} />
                      </button>
                    </Tooltip>}
                    {(item.status === 'Approved' || item.status === 'Declined' || item.status === 'Ordered' || item.status === 'Delivered' || item.status === 'Purchased') && <Tooltip content="View Request" style="light" arrow={false}>
                      <button className="hover:text-primary">
                        <MdOutlineRemoveRedEye  className='text-xl' onClick={() => handleEditRequestFromURL(item.status, item.id)} />
                      </button>
                    </Tooltip>}
                    {(item.status === 'Draft') && <Tooltip content="Delete Request" style="light" arrow={false}>
                      <button className="hover:text-primary">
                        <MdDelete  className='text-xl' onClick={() => handleDeleteRequest(item.id)} />
                      </button>
                    </Tooltip>}
                  </div>
                </td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
      {/* <div className="flex overflow-x-auto sm:justify-center mt-10">
                    <Pagination currentPage={1} totalPages={10} onPageChange={onPageChange} />
      </div> */}

      <Modal show={openModal} onClose={() => setOpenModal(false)} size={'sm'} theme={CustomThemeModal}>
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to create a draft request?
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="success" onClick={() => createNewRequest()} theme={CustomThemeButton}>
                {"Yes, I'm sure"}
              </Button>
              <Button color="gray" onClick={() => cancelCreateNew()} theme={CustomThemeButton}>
                No, cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={openDeleteModal} size="md" onClose={() => setOpenDeleteModal(false)} theme={CustomThemeModal} popup>
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200 mt-3" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to delete this request?
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="failure" onClick={() => handleSureToDeleteRequest()}>
                {"Yes, I'm sure"}
              </Button>
              <Button color="gray" onClick={() => setOpenDeleteModal(false)}>
                No, cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default MyRequestCard;